import React, { useEffect, useState } from "react";
// import TiffViewer from './TifViewer';
import MyTiffViewer from "./TifViewer";
import { DisplayMsg } from "../../services/toastService";
import { BASE_FILE_URL, setUrl } from "../../handlers";

const AttachImage = (props) => {
  const [imageUrl, setImageUrl] = useState("");

  const [showTif, setShowTif] = useState(false);

  useEffect(() => {
    if (props.fileType === "tiff" || props.fileType === "tif") {
      setImageUrl(props.data?.imageData);
      setShowTif(true);
    } else {
      setShowTif(false);
      setImageUrl(props.data?.imageData);
    }
  }, [props]);

  const loadTiffImage = (base64Data) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const image = new Image();

    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0);
      const dataURL = canvas.toDataURL("image/jpeg"); // or 'image/png'
      setImageUrl(dataURL);
    };

    image.src = base64Data;
  };

  const TriggerImage = () => {
    props.parentCallback(false);
  };

  const DownloadImage = async () => {
    try {
      const formData = new FormData();
      if (props.data?.filePath) {
        formData.append("fileName", props.data?.fileName);
        formData.append("filePath", props.data?.filePath);
        document.getElementById("loader").style.display = "block";
        const result = await fetch(
          setUrl("TICKETDETAIL", "DOWNLOAD_TASK_ATTACHMENTS"),
          {
            method: "POST",
            body: formData,
          }
        );
        const response = await result.json();
        if (response && response.status) {
          const updatedUrl = `${BASE_FILE_URL}${response.FileDirectory}&filename=${response.FileName}`;
          const a = document.createElement("a");
          a.href = updatedUrl;
          a.download = response.FileName;
          a.target = "_blank";
          a.click();

          document.getElementById("loader").style.display = "none";
          DisplayMsg("1", "File downloaded successfully");
        } else {
          document.getElementById("loader").style.display = "none";
          DisplayMsg("2", response.Message);
        }
      }
    } catch (e) {
      DisplayMsg("2", "File not downloaded");
    }
  };

  return (
    <div className="overlay imageIndex">
      <div className="popup">
        <div className="popup__header">
          <div className="col-7 flex-center-end">
            <h3>Attached Image</h3>
          </div>
          <div className="col-5 flex justify-content-end">
            <button className="mr-2" onClick={() => DownloadImage()}>
              Download Image
            </button>
            <span
              className="close close position-sticky"
              role="button"
              onClick={() => TriggerImage(false)}
            >
              ×
            </span>
          </div>
        </div>
        <div className="content">
          <div className="popup__body imageIndex">
            <div id="AttachedImagePopUp_Container" className="panCont">
              <div
                id="Support_Ticket_Viewer_container"
                className="panCont dataFormPan"
                align="center"
              >
                <div
                  id="pnlSupport_Ticket_Viewer"
                  style={{ marginTop: "20px", height: "440px" }}
                >
                  {showTif ? (
                    <MyTiffViewer data={imageUrl} />
                  ) : (
                    <img
                      id="imgTicketImage"
                      alt="HTML5 Icon"
                      src={`data:image/jpeg;base64,${imageUrl}`}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttachImage;
